import React, { useState, useEffect, useContext } from 'react';
import JobRecurService from "../../Controller/JobRecurController";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { handleChange, handleSubmit } from "../../Controller/CreateJobRecurController";
import JobService from "../../Controller/JobController";
import HelpSite from "../../../Common/HelpLink";
function JobsRecurPage({ JobID }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [JobRecurList, setJobRecurData] = useState([]);

    const { theme } = useContext(ThemeContext);
    const [modalInstance, setModalInstance] = useState(null);
    const [isClosed, SetIsClosed] = useState("0");
    const [formData, setFormData] = useState({
        FK_Issue_ID: JobID, snt_RecurType: "0", PK_Recur_ID: "0",
        snt_RecurFrequency: "0", snt_FrequencyAmount: "", snt_RecurEntries: "0", dt_Begin: ""
    });
    const [errors, setErrors] = useState({});
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const formatDate = (datetime) => {
        const date = new Date(datetime);

        // Define options for the date part
        const dateOptions = {
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        };
        const formattedDate = date.toLocaleDateString(undefined, dateOptions);

        // Get the hours and minutes
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        // Combine formatted date with time
        return `${formattedDate} ${hours}:${minutes}`;
    };
    const formatDate2 = (datetime) => {

        const date = new Date(datetime);

        // Get day, month, and year
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();

        const formattedDate = `${year}-${month}-${day}`;

        // Get hours and minutes
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const formattedTime = `${hours}:${minutes}`;

        return { formattedDate, formattedTime };
    };
    const fetchJobRecur = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await JobRecurService.GetAllJobRecurr(redirectCallback, JobID);
            setJobRecurData(data);
        } catch (error) {
            console.error('Error fetching Agreement Notifications:', error);
        }
    };
    const fetchJobDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (JobID > 0) {

                const jobDetail = await JobService.GetJobByID(redirectCallback, JobID);
                SetIsClosed(jobDetail[0].IsCompleted);

            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const fetchJobRecurByID = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await JobRecurService.GetJobRecur(redirectCallback, JobID);
            if (data.length > 0) {
                const { formattedDate, formattedTime } = formatDate2(data[0].dt_Begin);
                setFormData({
                    PK_Recur_ID: data[0].PK_Recur_ID,
                    snt_RecurType: data[0].snt_RecurType,
                    snt_RecurFrequency: data[0].snt_RecurFrequency,
                    snt_FrequencyAmount: data[0].snt_FrequencyAmount,
                    snt_RecurEntries: data[0].snt_RecurEntries,
                    dt_Begin: formattedDate,
                    dt_Begin_Time: formattedTime,

                });
            }
        } catch (error) {
            console.error('Error fetching Agreement Notifications:', error);
        }
    };

    useEffect(() => {
        SetIsClosed(localStorage.getItem("Closed"));
        fetchJobDetail();
        if (JobID > 0) {
            setJobRecurData([]);
            setFormData({
                FK_Issue_ID: JobID, snt_RecurType: "0",
                PK_Recur_ID: "0",
                snt_RecurFrequency: "0", snt_FrequencyAmount: "", snt_RecurEntries: "0", dt_Begin: ""
            });
            fetchJobRecur();
            fetchJobRecurByID();
        }
        else {
            setJobRecurData([]);
            setFormData({
                FK_Issue_ID: JobID, snt_RecurType: "0",
                PK_Recur_ID: "0",
                snt_RecurFrequency: "0", snt_FrequencyAmount: "", snt_RecurEntries: "0", dt_Begin: ""
            });
        }
    }, [JobID, localStorage.getItem("Closed")]);

    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        handleChange(event, formData, setFormData);
        if (name === 'snt_RecurType') {
            setFormData(prevFormData => ({
                ...prevFormData,
                snt_RecurEntries: '0', // Set to 0 when 'snt_RecurType' changes
            }));
        }
    };
    const handleFormSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission
        formData.ID = 0;
        formData.FK_Issue_ID = JobID;
        try {
            const redirectUserList = () => {
                navigate('/JobsList?saved=true');
            };
            const message = await handleSubmit(event, formData, setFormData, setErrors);
            if (message == "Data saved successfully") {
                let JobCostID = localStorage.getItem('JobCostID');
                JobCostID = JobCostID + 1;
                localStorage.setItem('JobCostID', JobCostID);
                setShowSuccessMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 5000);
                setJobRecurData([]);
                setFormData({
                    FK_Issue_ID: JobID, snt_RecurType: "0",
                    snt_RecurFrequency: "0", snt_FrequencyAmount: "", snt_RecurEntries: "0", dt_Begin: ""
                });
                fetchJobRecur();
                fetchJobRecurByID();
                // redirectUserList();
            }
            else {
                setShowErrorMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowErrorMessage(false);
                }, 5000);

            }


        } catch (error) {
            console.error('Error submitting form:', error);

        }
    };
    const handleDeleteClick = async (ID) => {

        const confirmed = window.confirm("Are you sure you want to delete this record?");
        if (confirmed) {
            try {
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };
                await JobRecurService.DeleteJobRecurByID(ID, redirectCallback);
                fetchJobRecur();
                fetchJobRecurByID();
            } catch (error) {
                console.error('Error deleting record:', error);
            }
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <div className="row mb-3">

                <div className="col-sm-12" style={{ textAlign: 'right' }}>

                </div>
            </div>
            <form onSubmit={handleFormSubmit}>
                <div className="row mb-3" style={{ marginLeft: "-5px", marginTop: "10px" }}>
                    <div className="col-sm-12">
                        <table style={{ width: "100%" }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: "13%" }}><label htmlFor="snt_FrequencyAmount" style={{ float: "right" }}>Frequency:<span style={{ "color": "red" }}>*</span></label></td>
                                    <td style={{ width: "37%" }}>
                                        <input type="hidden" className="form-control" name="PK_Recur_ID" value={formData.PK_Recur_ID} onChange={handleFieldChange} />
                                        <input type="number" className="form-control" name="snt_FrequencyAmount" value={formData.snt_FrequencyAmount} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                        {errors.snt_FrequencyAmount && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.snt_FrequencyAmount}</div>}
                                    </td>
                                    <td style={{ width: "13%" }}><label htmlFor="vc_Email" style={{ float: "right" }}></label></td>
                                    <td style={{ width: "37%" }}>
                                        <select name="snt_RecurFrequency" className='form-control' value={formData.snt_RecurFrequency} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                            <option value="0">No Recur</option>
                                            <option value="1">Hour(s)</option>
                                            <option value="2">Day(s)</option>
                                            <option value="3">Week(s)</option>
                                            <option value="4">Month(s)</option>

                                        </select>
                                        {errors.snt_RecurFrequency && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.snt_RecurFrequency}</div>}
                                    </td>


                                </tr>



                                <tr>
                                    <td><label htmlFor="snt_RecurType" style={{ float: "right" }}>Recurrance Type:<span style={{ "color": "red" }}>*</span></label></td>
                                    <td>
                                        <select name="snt_RecurType" className='form-control' value={formData.snt_RecurType} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                            <option value="0">Continuous</option>
                                            <option value="1">Fixed</option>


                                        </select>
                                    </td>
                                    <td><label htmlFor="snt_RecurEntries" style={{ float: "right" }}>Entries</label></td>
                                    <td>
                                        <input type="number" className="form-control" name="snt_RecurEntries" value={formData.snt_RecurEntries} onChange={handleFieldChange} disabled={formData.snt_RecurType === '0' || formData.snt_RecurType === 0} />
                                        {errors.snt_RecurEntries && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.snt_RecurEntries}</div>}
                                    </td>


                                </tr>

                                <tr>
                                    <td><label htmlFor="dt_Begin" style={{ float: "right" }}>Date:<span style={{ "color": "red" }}>*</span></label></td>
                                    <td>
                                        <input type="date" className="form-control" name="dt_Begin" value={formData.dt_Begin} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                        {errors.dt_Begin && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.dt_Begin}</div>}
                                    </td>
                                    <td><label htmlFor="dt_Begin_Time" style={{ float: "right" }}>Time</label></td>
                                    <td>
                                        <input type="time" className="form-control" name="dt_Begin_Time" value={formData.dt_Begin_Time} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                        {errors.dt_Begin_Time && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.dt_Begin_Time}</div>}
                                    </td>


                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <button type="submit" className="btn btn-primary" style={{ "float": "right", "marginLeft": "5px" }} disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                                           <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> Save
                                        </button>
                                        {JobRecurList.length > 0 && (
                                            <button type="button" className="btn btn-danger" onClick={() => handleDeleteClick(formData.PK_Recur_ID)} style={{ "float": "right" }} disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                                                <i className="icofont-ui-delete" aria-hidden="true"> Delete</i>
                                            </button>
                                        )}


                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </form >
            <div className="row mb-3" style={{ marginLeft: "-5px", marginTop: "10px" }}>
                <div className="col-sm-12">
                    <div className="">
                        <div className='divTable'>
                            <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                <thead>
                                    <tr>
                                        <th>Scheduled For</th>
                                    </tr>
                                </thead>
                            </table>
                            <div style={{ maxHeight: "370px", overflow: "auto" }}>
                                <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                    <tbody>
                                        {JobRecurList.map((job, index) => (
                                            <tr key={job.PK_Recur_ID}>
                                                <td>{formatDate(job.dt_TimeToCall)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default JobsRecurPage;
